export default __webpack_public_path__ + "static/media/fb-white.ae36aed0.svg";